import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { TmsWebBaseEditCreateService } from '../base';
import {
  CreateFromContractResult,
  SalesContractForOrder,
  SalesContractLine,
  SalesContractLineDetails,
  SalesContractLineForCreate,
  SalesContractLineHeader,
  SalesContractLineList,
  SalesContractLineQuickCreate,
  SalesContractLineSelect,
  SalesOrderFromPreviousIds,
} from '../../models';

@Injectable({
  providedIn: 'root',
})
export class SalesContractLineService extends TmsWebBaseEditCreateService<SalesContractLine, SalesContractLineDetails> {
  public refreshDetails = new Subject<void>();

  constructor() {
    super('SalesContractLine', $localize`Sales Contract Line`);
  }

  getForSalesContractHeader(id: string): Observable<SalesContractLineHeader[]> {
    return this.httpService.get<SalesContractLineHeader[]>(`${this.apiUrl}/SalesContractHeader?id=${id}`);
  }

  quickCreate(SalesContractLineQuickCreate: SalesContractLineQuickCreate): Observable<any> {
    return this.httpService.post(`${this.apiUrl}/QuickCreate`, SalesContractLineQuickCreate);
  }

  getSelectItems(customerId: string): Observable<SalesContractLineSelect[]> {
    return this.httpService.get<SalesContractLineSelect[]>(`${this.apiUrl}/GetSelectItems?customerId=${customerId}`);
  }

  getForSalesOrder(id: string, salesOrderHeaderId?: string): Observable<SalesContractForOrder> {
    const headerParam = salesOrderHeaderId ? `&salesOrderHeaderId=${salesOrderHeaderId}` : '';
    return this.httpService.get<SalesContractForOrder>(`${this.apiUrl}/GetForSalesOrder?id=${id}${headerParam}`);
  }

  getOutstandingContracts(search: string): Observable<SalesContractLineForCreate[]> {
    return this.httpService.get<SalesContractLineForCreate[]>(
      `${this.apiUrl}/GetOutstandingContracts?search=${search}`,
    );
  }

  getFromContract(customerId: string, search: string): Observable<SalesContractLine[]> {
    return this.httpService.get<SalesContractLine[]>(
      `${this.apiUrl}/GetFromContract?customerId=${customerId}&search=${search}`,
    );
  }

  getForSalesContractLineList(search: string): Observable<SalesContractLineList[]> {
    return this.httpService.get<SalesContractLineList[]>(`${this.apiUrl}/GetForSalesContractLineList?search=${search}`);
  }

  createFromContract(
    salesOrderHeaderId: string,
    ids: SalesOrderFromPreviousIds[],
  ): Observable<CreateFromContractResult> {
    return this.httpService.post<CreateFromContractResult>(`${this.apiUrl}/CreateFromContract`, {
      salesOrderHeaderId,
      ids,
    });
  }
}
